import {
    isScreenAtLeast,
    throttle,
} from '../common/utils';

const {
    computed,
    createApp,
    ref,
    onMounted,
    nextTick,
} = Vue;

const els = {
    $app: () => $('[data-properties-grid]'),
    $stateSelect: () => els.$app().find('[data-state-select]'),
    $statusSelect: () => els.$app().find('[data-status-select]'),
    $ownershipSelect: () => els.$app().find('[data-ownership-select]'),
    $tiles: () => els.$app().find('[data-tile]'),
    $visibleTiles: () => els.$tiles().filter(':visible'),
    $lineRight: ($tile) => $tile.find('[data-line-right]'),
    $lineDown: ($tile) => $tile.find('[data-line-down]'),
};

const setupApp = () => {

    const properties = (
        window.pageData.properties
            .sort((a, b) => {
                if (a.sort === b.sort) return 0;
                return a.sort > b.sort ? 1 : -1;
            })
    );

    const selectedState = ref(0);
    const selectedStatus = ref(0);
    const selectedOwnership = ref(0);

    const filteredProperties = computed(() => (
        properties
            .filter((property) => (
                selectedState.value == 0
                || property.city.state.value == selectedState.value
            ))
            .filter((property) => (
                selectedStatus.value == 0
                || property.status.id == selectedStatus.value
            ))
            .filter((property) => (
                selectedOwnership.value == 0
                || property.tdk_owned == selectedOwnership.value
            ))
    ));

    const isPropertyFilteredOut = (property) => (
        !filteredProperties.value
            .map((property) => property.id)
            .includes(property.id)
    );

    const states = (
        properties
            .map((property) => property.city.state)
            .reduce(
                (states, state) => {
                    if (
                        states.find(
                            (s) => s.value == state.value
                        ) === undefined
                    ) {
                        states.push(state);
                    }
                    return states;
                },
                []
            )
            .sort(
                (a, b) => {
                    if (a.label === b.label) return 0;
                    return a.label > b.label ? 1 : -1;
                }
            )
    );

    const statuses = (
        properties
            .map((property) => property.status)
            .reduce(
                (statuses, status) => {
                    if (
                        statuses.find(
                            (s) => s.id == status.id
                        ) === undefined
                    ) {
                        statuses.push(status);
                    }
                    return statuses;
                },
                []
            )
    );

    const resetFilters = () => {
        selectedState.value = 0;
        selectedStatus.value = 0;
        nextTick(animateTiles);
    };

    const updateConnectors = () => {

        const columnCount = (() => {

            if (isScreenAtLeast('lg')) return 3;
            if (isScreenAtLeast('md')) return 2;
            return 1;
        })();

        const $visibleTiles = els.$visibleTiles();

        $visibleTiles.each((index, element) => {

            const $tile = $(element);
            const $lineRight = els.$lineRight($tile);
            const $lineDown = els.$lineDown($tile);

            if (columnCount === 1) {

                $lineRight.hide();

                $lineDown.toggle(
                    index < $visibleTiles.length - 1
                );

            } else if (columnCount === 2) {

                $lineRight.toggle(
                    (index + 1) % 2 > 0
                    && index !== $visibleTiles.length - 1
                );

                $lineDown.toggle(
                    index < $visibleTiles.length - 2
                );

            } else if (columnCount === 3) {

                $lineRight.toggle(
                    (index + 1) % 3 > 0
                    && index !== $visibleTiles.length - 1
                );

                $lineDown.toggle(
                    index < $visibleTiles.length - 3
                );
            }
        });
    };

    const animateTiles = () => {
        gsap.set(
            els.$visibleTiles(),
            { autoAlpha: 0 }
        );
        updateConnectors();
        gsap.to(
            els.$visibleTiles(),
            {
                autoAlpha: 1,
                stagger: 0.1,
            }
        );
    };

    onMounted(() => {

        els.$stateSelect()
            .select2({
                width: 'style',
                placeholder: 'Filter by State',
                minimumResultsForSearch: Infinity,
            })
            .on('select2:select', function(event) {
                selectedState.value = event.params.data.id;
                nextTick(animateTiles);
            });

        els.$statusSelect()
            .select2({
                width: 'style',
                placeholder: 'Filter by Project Status',
                minimumResultsForSearch: Infinity,
            })
            .on('select2:select', function(event) {
                selectedStatus.value = event.params.data.id;
                nextTick(animateTiles);
            });

        els.$ownershipSelect()
            .select2({
                width: 'style',
                placeholder: 'Filter by Ownership',
                minimumResultsForSearch: Infinity,
            })
            .on('select2:select', function(event) {
                selectedOwnership.value = event.params.data.id;
                nextTick(animateTiles);
            });

        animateTiles();

        $(window).on(
            'resize:horizontally',
            throttle(
                () => {
                    animateTiles();
                },
                50
            )
        );
    });

    return {
        properties,
        filteredProperties,
        isPropertyFilteredOut,
        resetFilters,
        states,
        statuses,
    };
};

const initialize = () => {

    const app = createApp({ setup: setupApp });

    const element = els.$app().get(0);

    window.vues.propertiesGrid = app.mount(element);
};

export default {
    initialize,
};

